function shopify_buy_button(element, variant) {
  let id = "9062592479565"
  let variantID = "49008874750285"
  if (variant === "dashboard-variant") {
    id = "9732775510349"
    variantID = "50140590309709"
  }

  const client = window.ShopifyBuy.buildClient({
    domain: "b26336-4.myshopify.com",
    storefrontAccessToken: "373a5d790e798e28fa91eeea3796022d",
    language: window.gon.locale
  })
  const ui = window.ShopifyBuy.UI.init(client)
  ui.createComponent("product", {
    id,
    variantID,
    node: element,
    moneyFormat: "%24%7B%7Bamount%7D%7D",
    options: {
      product: {
        styles: {
          product: {
            "@media (min-width: 601px)": {
              "max-width": "calc(25% - 20px)",
              "margin-left": "20px",
              "margin-bottom": "50px"
            }
          },
          button: {
            "font-family": "PlutoSansMedium, sans-serif",
            "font-weight": "normal",
            "text-transform": "uppercase",
            "font-size": "12px",
            "padding-top": "12px",
            "padding-bottom": "12px",
            "padding-left": "18px",
            "padding-right": "18px",
            ":hover": {
              "background-color": "#008ae6"
            },
            "background-color": "#0099ff",
            ":focus": {
              "background-color": "#008ae6"
            }
          },
          quantityInput: {
            "font-size": "16px",
            "padding-top": "16px",
            "padding-bottom": "16px"
          }
        },
        buttonDestination: "checkout",
        contents: {
          img: false,
          title: false,
          price: false,
          options: false
        },
        text: {
          button: "Buy now"
        },
        googleFonts: [
          "PT Sans"
        ]
      },
      productSet: {
        styles: {
          products: {
            "@media (min-width: 601px)": {
              "margin-left": "-20px"
            }
          }
        }
      },
      modalProduct: {
        contents: {
          img: false,
          imgWithCarousel: true
        },
        styles: {
          product: {
            "@media (min-width: 601px)": {
              "max-width": "100%",
              "margin-left": "0px",
              "margin-bottom": "0px"
            }
          },
          button: {
            "font-family": "PlutoSansMedium, sans-serif",
            "font-weight": "normal",
            "font-size": "16px",
            "padding-top": "16px",
            "padding-bottom": "16px",
            "text-transform": "uppercase",
            ":hover": {
              "background-color": "#008ae6"
            },
            "background-color": "#0099ff",
            ":focus": {
              "background-color": "#008ae6"
            }
          },
          quantityInput: {
            "font-size": "16px",
            "padding-top": "16px",
            "padding-bottom": "16px"
          }
        },
        googleFonts: [
          "PT Sans"
        ],
        text: {
          button: "Add to cart"
        }
      },
      option: {},
      cart: {
        styles: {
          button: {
            "font-family": "PT Sans, sans-serif",
            "font-weight": "bold",
            "font-size": "16px",
            "padding-top": "16px",
            "padding-bottom": "16px",
            ":hover": {
              "background-color": "#008ae6"
            },
            "background-color": "#0099ff",
            ":focus": {
              "background-color": "#008ae6"
            }
          }
        },
        text: {
          total: "Subtotal",
          button: "Checkout"
        },
        popup: false,
        googleFonts: [
          "PT Sans"
        ]
      },
      toggle: {
        styles: {
          toggle: {
            "font-family": "PT Sans, sans-serif",
            "font-weight": "bold",
            "background-color": "#0099ff",
            ":hover": {
              "background-color": "#008ae6"
            },
            ":focus": {
              "background-color": "#008ae6"
            }
          },
          count: {
            "font-size": "16px"
          }
        },
        googleFonts: [
          "PT Sans"
        ]
      }
    }
  })
}

export default shopify_buy_button
